// extracted by mini-css-extract-plugin
module.exports = {"span-link":"span-link--808a25","spanLink":"span-link--808a25","span-link_pseudo":"span-link_pseudo--65936e","spanLink_pseudo":"span-link_pseudo--65936e"};